import React from 'react'

const QABox = (props) => {

    return (
        <>
            <div className="col-md-6">
    <div className="">
    <h3>{props.head}</h3>
    <p className="text-justify">{props.para}</p>

    </div>
</div>
        </>
    )
}

export default QABox
